/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface LabelBoxDataRow
 *
 */
// create custom validators for the regexes
export interface LabelBoxDataRow {
    /**
     * The task_id for importing into LabelBox.
     * #type string
     * #memberof LabelBoxDataRow
        
        
         */
    externalId: string;
    /**
     * A URL which allows anyone in possession of said URL for the time specified by the expiresIn query param to access the resource
     * #type string
     * #memberof LabelBoxDataRow
        
        
         */
    imageUrl: string;
}
/**
 * Check if a given object implements the LabelBoxDataRow interface.
 */
export function instanceOfLabelBoxDataRow(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "externalId" in value;
    isInstance = isInstance && "imageUrl" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const LabelBoxDataRowTypiaAssertEquals = (input: any) => {
    return ((input: any): LabelBoxDataRow => {
        const __is = (input: any, _exceptionable: boolean = true): input is LabelBoxDataRow => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.externalId && "string" === typeof input.imageUrl && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["externalId", "imageUrl"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is LabelBoxDataRow => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.externalId || $guard(_exceptionable, {
                    path: _path + ".externalId",
                    expected: "string",
                    value: input.externalId
                })) && ("string" === typeof input.imageUrl || $guard(_exceptionable, {
                    path: _path + ".imageUrl",
                    expected: "string",
                    value: input.imageUrl
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["externalId", "imageUrl"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "LabelBoxDataRow",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "LabelBoxDataRow",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const LabelBoxDataRowTypiaAssertStringify = (input: LabelBoxDataRow): string => {
    return ((input: any): string => { const assert = (input: any): LabelBoxDataRow => {
        const __is = (input: any): input is LabelBoxDataRow => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).externalId && "string" === typeof (input as any).imageUrl);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is LabelBoxDataRow => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.externalId || $guard(_exceptionable, {
                    path: _path + ".externalId",
                    expected: "string",
                    value: input.externalId
                })) && ("string" === typeof input.imageUrl || $guard(_exceptionable, {
                    path: _path + ".imageUrl",
                    expected: "string",
                    value: input.imageUrl
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "LabelBoxDataRow",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "LabelBoxDataRow",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: LabelBoxDataRow): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"externalId":${$string((input as any).externalId)},"imageUrl":${$string((input as any).imageUrl)}}`;
    }; return stringify(assert(input)); })(input);
};
export const LabelBoxDataRowValidatorShape = {
    'externalId': yup.string().defined(),
    'imageUrl': yup.string().defined(),
};
export const LabelBoxDataRowValidator = yup.object().shape(LabelBoxDataRowValidatorShape);
export const LabelBoxDataRowStringifyShapeProperties: ObjectSchema['properties'] = {
    'externalId': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'imageUrl': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const LabelBoxDataRowStringifyShape: ObjectSchema = {
    title: 'LabelBoxDataRow Stringifier',
    type: 'object',
    properties: {
        ...LabelBoxDataRowStringifyShapeProperties
    },
    required: [
        'externalId',
        'imageUrl',
    ],
};
export const LabelBoxDataRowStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(LabelBoxDataRowStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const LabelBoxDataRowStringify: (data: LabelBoxDataRow) => string = LabelBoxDataRowStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function LabelBoxDataRowFromJSON(json: any): LabelBoxDataRow {
    return LabelBoxDataRowFromJSONTyped(json, false);
}
export function LabelBoxDataRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelBoxDataRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'externalId': json['externalId'],
        'imageUrl': json['imageUrl'],
    };
}
export function LabelBoxDataRowToJSON(value?: LabelBoxDataRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'externalId': value.externalId,
        'imageUrl': value.imageUrl,
    };
}
